export const setCalenderEvents = ({
	project,
	roleDescription,
	clientList,
    startDateField,
    endDateField,
	startDate,
	endDate,
    start_assembly_datetime,
    end_assembly_datetime,
    start_production_datetime,
    end_production_datetime,
    start_transport_datetime,
    end_transport_datetime,
	serverUsers = [],
	projectCategory = []
}) => {
	const filterRelatedUsers = (category) =>
		serverUsers
			.filter((user) => category.includes(user.id))
			.map((detailInfo) => {
				return ` ${detailInfo.firstname} ${detailInfo.lastname}`;
			});

	const mapUsersByName = filterRelatedUsers(projectCategory);

    let endDatePlusOne;

    if (endDate) {
        endDatePlusOne = new Date(endDate);
        endDatePlusOne.setDate(endDatePlusOne.getDate() + 1);
    }

	return {
		title: `${startDate.split(' ').pop()} ${project.title} | ${project.id} ${
			clientList[project.client_id] ? clientList[project.client_id]['title'] : ''
		} | ${roleDescription} ${mapUsersByName}`,
        start_assembly_datetime,
        end_assembly_datetime,
        start_production_datetime,
        end_production_datetime,
        start_transport_datetime,
        end_transport_datetime,
        startDateField,
        endDateField,
        startDate,
        endDate,
        projectId: project.id,
		start: `${startDate}`,
		end: `${endDatePlusOne.toISOString()}`,
		classNames: [
			`${project.status}`,
			`${project.category}`,
			`${project.is_knapphus_brand === 1 ? 'knapphus' : ''}`
		],
        allDay: true,
		url: `project-active/${project.id}`
	};
};

export const timeConvert = (n) => {
	let num = n;

	let hours = num / 60;

	let rhours = Math.floor(hours);

	let minutes = (hours - rhours) * 60;

	let rminutes = Math.round(minutes) > 0 ? Math.round(minutes) : '00';
	return ` - ${rhours}h ${rminutes}m`;
};
